const CATALOG_FIELD_IDS = new Set([
  'selected-product',
  'selectedProductId',
  'configurationValues',
]);

/**
 * Drop hydrated product catalog snapshots from a configurator submission.
 *
 * `selected-product` and `productUpsells` embed the full product graph
 * (options, pricing matrix, nested upsells). Persisting that on every
 * partial/final submit writes multiple MB of JSONB and hits statement
 * timeouts. Runtime UI keeps the live catalog in memory; only IDs and
 * the customer's configuration belong in the payload.
 */
export function stripConfiguratorCatalog(submissionData) {
  if (!submissionData || typeof submissionData !== 'object' || Array.isArray(submissionData)) {
    return submissionData;
  }

  const cleaned = { ...submissionData };
  CATALOG_FIELD_IDS.forEach((fieldId) => {
    delete cleaned[fieldId];
  });

  if (Array.isArray(cleaned._configuredProducts)) {
    cleaned._configuredProducts = cleaned._configuredProducts.map(stripConfiguredProductCatalog);
  }

  return cleaned;
}

function stripConfiguredProductCatalog(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const { productUpsells, ...rest } = item;
  return rest;
}
